<template>
<div>
  <b-row>
    <b-col>
      <card-ticket-medio/>
    </b-col>
    
    <b-col>
      <card-teste-vencendo/>
    </b-col>
  </b-row>
  
  <b-row>
   
    <b-col>
      <card-cancelados/>
    </b-col>
    <b-col>
      <card-inatividade/>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <card-teste-gratis-x-assinantes/>
    </b-col>
  </b-row>
</div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, } from 'bootstrap-vue'
import CardAtendimentos from './dashboard/CardAtendimentos.vue'
import { mapState } from 'vuex'
import CardTesteGratisXAssinantes from './dashboard/CardTesteGratisXAssinantes.vue'
import CardTicketMedio from './dashboard/CardTicketMedio.vue'
import CardTesteVencendo from "@/views/dashboard/CardTesteVencendo.vue";
import CardCancelados from "@/views/dashboard/CardCancelados.vue";
import CardInatividade from "@/views/dashboard/CardInatividade.vue";

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BRow,
    BCol,
    CardAtendimentos,
    CardTesteGratisXAssinantes,
    CardTicketMedio,
    CardTesteVencendo,
    CardCancelados,
    CardInatividade,

  },
  computed: {
    ...mapState({
      me: (state) => state.user.user
    })
  },

}
</script>

<style>

</style>
